<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <branches-dropdown
        class="d-none d-lg-block"
      />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">

      <div
        v-b-tooltip.hover.bottom="message.whatsapp"
        :class="['d-none', 'd-lg-flex', 'align-items-center', 'justify-content-center', 'nav-icon', 'font-weight-500', 'integrations-nav-link', 'm-0']"
      >
        <whatsapp
          class="margin-right-3px"
        />
        <div
          :style="{transformOrigin:isRTL?'3px 27px':'-13px 11px'}"
          style="width: 4px; height: 24px; transform: rotate(90deg); border-radius: 4px; overflow: hidden; flex-direction: column; justify-content: flex-end; display: inline-flex"
        >
          <div :style="`width: 4px; height: 8px; position: relative; background: ${getColor(message.whatsapp)}`" />
          <div :style="`width: 4px; height: 8px; position: relative; background: ${getColor(message.whatsapp)}; border-top: 1px rgba(75, 70, 92, 0.48) solid`" />
          <div :style="`width: 4px; height: 8px; position: relative; background: ${getColor(message.whatsapp)}; border-top: 1px rgba(75, 70, 92, 0.48) solid`" />
        </div>
      </div>

      <div
        v-b-tooltip.hover.bottom="message.email"
        :class="['d-none', 'd-lg-flex', 'align-items-center', 'justify-content-center', 'nav-icon', 'font-weight-500', 'integrations-nav-link', 'm-0', 'border-right-2']"
      >
        <email
          class="margin-right-3px"
        />
        <div
          :style="{transformOrigin:isRTL?'3px 27px':'-13px 11px'}"
          style="width: 4px; height: 24px; transform: rotate(90deg); border-radius: 4px; overflow: hidden; flex-direction: column; justify-content: flex-end; display: inline-flex"
        >
          <div :style="`width: 4px; height: 8px; position: relative; background: ${getColor(message.email)}`" />
          <div :style="`width: 4px; height: 8px; position: relative; background: ${getColor(message.email)}; border-top: 1px rgba(75, 70, 92, 0.48) solid`" />
          <div :style="`width: 4px; height: 8px; position: relative; background: ${getColor(message.email)}; border-top: 1px rgba(75, 70, 92, 0.48) solid`" />
        </div>
      </div>
      <!--      <div-->
      <!--        class="border-right-2 flex-row justify-content-around"-->
      <!--      >-->
      <!--        <whatsapp-->
      <!--          v-b-tooltip.hover.top="whatsappConsumedNumber + '/' + message.whatsapp"-->
      <!--          class="margin-right-3px"-->
      <!--        />-->
      <!--        &lt;!&ndash;        <message class="margin-right-3px" />&ndash;&gt;-->
      <!--        <email-->
      <!--          v-b-tooltip.hover.top="emailsConsumedNumber + '/' + message.email"-->
      <!--          class="margin-right-3px"-->
      <!--        />-->
      <!--      </div>-->
      <locale />

      <router-link
        v-if="canViewIntegrations"
        :to="{name: 'admin:store'}"
        :title="$t('integrations.title')"
        :class="['d-flex', 'align-items-center', 'justify-content-center', 'nav-icon', 'font-weight-500', 'integrations-nav-link']"
        active-class="text-white bg-primary store-active"
      >
        <store-icon />
      </router-link>

      <feather-icon
        v-if="canPreviewMenu"
        v-b-modal.preview-modal
        class="d-none d-lg-block nav-icon"
        :title="$t('qr-code.preview')"
        size="21"
        icon="EyeIcon"
      />
      <feather-icon
        class="d-none d-lg-block cursor-pointer nav-icon"
        size="21"
        icon="HelpCircleIcon"
        :title="$t('help.help')"
        @click="openFreshchat"
      />
      <notification-dropdown />
      <profile-actions-dropdown />
    </b-navbar-nav>
    <qr-menu-preview-modal />
  </div>
</template>

<script>
import {
  BNavbarNav, BLink, VBToggle, VBModal, VBTooltip,
} from 'bootstrap-vue'
import Locale from '@core/layouts/components/app-navbar/components/Locale.vue'
import ProfileActionsDropdown from '@core/layouts/components/app-navbar/components/ProfileActionsDropdown.vue'
import BranchesDropdown from '@core/layouts/components/app-navbar/components/BranchesDropdown.vue'
import PermissionMixin from '@/mixins/permission-mixin'
import SUBUSER_PERMISSION_SLUGS from '@/constants/authorization/subuser-permission-slugs'
import QrMenuPreviewModal from '@/views/admin/user/QrMenuPreviewModal'
import FreshchatService from '@/services/FreshchatService'
import { getEnvironment } from '@/utils/env-helper'
import MarketingService from '@/services/marketing-service'
import StorageService from '@/services/storage-service'
import UserAPIs from '@/API/user-api'
import StoreIcon from '@/@okmenu/icons/StoreIcon.vue'
// import Message from '@/@okmenu/icons/Message.vue'
import Whatsapp from '@/@okmenu/icons/Whatsapp.vue'
import Email from '@/@okmenu/icons/Email.vue'

export default {
  components: {
    StoreIcon,
    // Message,
    Whatsapp,
    Email,
    QrMenuPreviewModal,
    NotificationDropdown: () => import(/* webpackChunkName: "notifications" */ '@core/layouts/components/app-navbar/components/NotificationDropdown.vue'),
    BLink,
    Locale,
    BNavbarNav,
    // Navbar Components
    BranchesDropdown,
    ProfileActionsDropdown,
  },
  directives: {
    'b-toggle': VBToggle,
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
  },
  mixins: [PermissionMixin],
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => null,
    },
  },

  computed: {
    // canViewOrderNotifications() {
    //   if (this.isPrimaryAccount) return true
    //   return this.hasSubuserPermission(SUBUSER_PERMISSION_SLUGS.ORDERS_NOTIFICATIONS_VIEW)
    // },
    canViewIntegrations() {
      return this.hasSubuserPermission(SUBUSER_PERMISSION_SLUGS.INTEGRATIONS_VIEW)
    },
    canPreviewMenu() {
      return this.hasSubuserPermission(SUBUSER_PERMISSION_SLUGS.MENU_VIEW)
    },
    message() {
      return this.$store.getters['branches/messages']
    },
    showDeleteAccount() {
      return getEnvironment() !== 'Live'
    },
  },
  mounted() {
    this.getMessagePacksStatics()
  },
  methods: {
    openFreshchat() {
      FreshchatService.openFreshchat()
    },
    logout() {
      this.$store.dispatch('auth/LOGOUT')
      MarketingService.storeCampaign(null)
      StorageService.removeItem('okmenu_route_after_auth')
      window.location.replace(this.$router.resolve({ name: 'login' }).href)
    },
    deleteAccount() {
      this.$swal({
        title: this.$t('forms.are-you-sure'),
        text: 'This process cannot be reverted. Please confirm it',
        icon: 'error',
        showCancelButton: true,
        confirmButtonText: this.$t('forms.confirm'),
        cancelButtonText: this.$t('forms.cancel'),
        showCloseButton: false,
        showLoaderOnConfirm: true,
        allowOutsideClick: () => false,
        preConfirm: () => UserAPIs.deleteAccount()
          .then(({ message }) => {
            this.logout(message)
          })
          .catch(error => {
            this.$swal.showValidationMessage(
              `${error}`,
            )
          }),
      }).then(() => {
        /* Read more about handling dismissals below */
      })
    },
    getMessagePacksStatics() {
      this.$store.commit('branches/SET_MESSAGES')
    },
    getColor(remaining) {
      if (remaining < 1000) return 'red'
      if (remaining < 2000) return 'orange'
      return '#28c76f'
    },
  },
}
</script>

<style lang="scss">
.navbar-container {
  .nav-icon {
    margin: 0 9px;
  }

  .integrations-nav-link {
    color: var(--secondary);

    body.dark-layout & {
      color: #b4b7bd;
    }
  }

  .integrations-nav-text {
    font-weight: 500;
    color: #4F4F4F;

    body.dark-layout & {
      color: #b4b7bd;
    }
  }
  .store-active {
    padding: 4px;
    border-radius: 5px;
    background-color: var(--primary) !important;
  }
  .store-active:focus{
    background-color: var(--primary) !important;
  }

  .border-right-2{
    border-right: 2px #6e6b7b solid;
    padding-right: 3px;
  }

  .margin-right-3px{
    margin-right: 3px;
  }
}
</style>
